var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0C27.9345 0 36 8.06555 36 18C36 27.9345 27.9345 36 18 36C8.06555 36 0 27.9345 0 18C0 8.06555 8.06555 0 18 0ZM28.78 12.5844C28.5212 11.6163 27.7589 10.854 26.7908 10.5953C25.036 10.125 18 10.125 18 10.125C18 10.125 10.964 10.125 9.20918 10.5953C8.24133 10.854 7.47879 11.6163 7.22004 12.5844C6.75 14.339 6.75 18.0001 6.75 18.0001C6.75 18.0001 6.75 21.6611 7.22004 23.4156C7.47879 24.3837 8.24133 25.1463 9.20918 25.405C10.964 25.875 18 25.875 18 25.875C18 25.875 25.036 25.875 26.7908 25.405C27.7589 25.1463 28.5212 24.3837 28.78 23.4156C29.25 21.6611 29.25 18.0001 29.25 18.0001C29.25 18.0001 29.25 14.339 28.78 12.5844ZM15.7499 21.3752V14.6251L21.5955 18.0001L15.7499 21.3752Z",
    fill: "#444444"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeB);
export default __webpack_public_path__ + "static/media/youtubeB.53bab6f1334966f1ca1e4cf7ff71315f.svg";
export { ForwardRef as ReactComponent };